// Persistence for the "Move hints" preference, stored in the shared
// `bao_settings` object. Coercion rule (non-obvious): hints are ON unless the
// stored value is explicitly `false`, so legacy/undefined settings default to on.

import { readSettingsObject, writeSetting } from "src/utils/baoSettingsStorage";

const DEFAULT_SHOW_HINTS = true;

export function loadShowHints(): boolean {
  const settings = readSettingsObject();
  if (!settings) {
    return DEFAULT_SHOW_HINTS;
  }
  return settings.showHints !== false;
}

export function saveShowHints(showHints: boolean): void {
  writeSetting("showHints", showHints);
}
